module.exports = __webpack_public_path__ + "img/download.336f06ea.svg";